<template>
  <Drawer
    title="街景"
    placement="right"
    :closable="true"
    :mask="false"
    :draggable="true"
    width="400"
    v-model="openStree"
  >
    <div id="lystree" v-if="openStree"></div>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openStree: false,
    };
  },
  methods: {
    open(v) {
      this.mapData = v;
      this.openStree = false;

      this.convert();
    },
    stree(lng, lat) {
      this.openStree = true;
      setTimeout(() => {
        var panorama = new BMapGL.Panorama("lystree");
        panorama.setPosition(new BMapGL.Point(lng, lat));
      }, 500);
    },
    convert(v) {
      this.utils.loading(this, "加载中");
      let params = {
        orgCoord: 1,
        pointList: [
          {
            x: this.mapData.orgX,
            y: this.mapData.orgY,
          },
        ],
        returnCoord: 3,
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/lbs/convert",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        if (res) {
          var data = res.data.data[0];
          this.stree(data.x, data.y);
        }
      });
    },
  },
  mounted() {
    //this.stree();
  },
};
</script>
<style lang="">
#lystree {
  height: 100%;
  background: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/stree.vue